const $html = document.documentElement
const $body = document.body

export {
    $html,
    $body,
}
